import { useEffect, useState } from 'react';
import { PROXY_SESSION_ID_KEY } from '../../MPP-Common-SPA/utils/globalUtility';

export const useSessionLock = () => {
    const [isLocked, setIsLocked] = useState(false);

    useEffect(() => {
        //This only fires if ANOTHER tab changes the storage
        const handleStorageChange = (event: StorageEvent) => {

            // 1. Check if the changed key is ours
            if (event.key === PROXY_SESSION_ID_KEY) {
                // 2. Lock the UI immediately
                setIsLocked(true);
            }
        };
        //Listener
        window.addEventListener('storage', handleStorageChange);
        // Cleanup on unmount
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    return isLocked;
};